<template>
    <div>
        <b-table-simple small bordered responsive class="mb-4">
            <b-thead>
                <b-tr>
                    <b-th>{{ $t('program_code') }}</b-th>
                    <b-th>{{ $t('program_name') }}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr>
                    <b-td>{{ localApp.bau_program_code }}</b-td>
                    <b-td>{{ getLocaleText(localApp, 'bau_program_name') }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <span class="badge badge-success mb-3 px-3 py-1">{{ $t('selected_courses') }}</span>

        <b-table-simple small bordered responsive class="mt-2">
            <b-thead>
                <b-tr>
                    <b-th>{{ $t('course_code') }}</b-th>
                    <b-th>{{ $t('course_name') }}</b-th>
                    <b-th>{{ $t('course_type') }}</b-th>
                    <b-th>{{ $t('section') }}</b-th>
                    <b-th>{{ $t('credit') }}</b-th>
                    <b-th>{{ $t('instructor') }}</b-th>
                    <b-th>{{ isGraduate ? $t('institute_review') : $t('academic_unit_review') }}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <template v-for="(course, idx) in localApp?.courses">
                    <b-tr :key="'course-'+idx">
                        <b-td class="align-middle">{{ course.course_code }}</b-td>
                        <b-td class="align-middle">{{ getLocaleText(course, 'course_name') }}</b-td>
                        <b-td class="align-middle">{{ getLocaleText(course, 'course_type_name') || course.course_type }}</b-td>
                        <b-td class="align-middle">{{ course.section }}</b-td>
                        <b-td class="align-middle">{{ course.credit }}</b-td>
                        <b-td class="align-middle">{{ course.instructor_name || '-' }}</b-td>
                        <b-td class="align-middle text-center">
                            <ValidationObserver :ref="'courseObserver' + idx" :key="idx">
                                <b-button-group size="sm">
                                    <b-button :variant="'success'"
                                              class="font-weight-bold px-3"
                                              :disabled="checkApprover || course.status==='approved'"
                                              @click="handleEvaluateCourse(course, 'approved', idx)">
                                        {{ $t('approve') }}
                                    </b-button>
                                    <b-button :variant="'danger'"
                                              class="font-weight-bold px-3"
                                              :disabled="checkApprover || course.status==='rejected'"
                                              @click="handleEvaluateCourse(course, 'rejected', idx)">
                                        {{ $t('reject') }}
                                    </b-button>
                                </b-button-group>
                            </ValidationObserver>
                        </b-td>
                    </b-tr>

                    <b-tr v-if="course.status === 'rejected'" :key="'reason-'+idx">
                        <b-td colspan="7" class="bg-light">
                            <b-form-group :label="$t('rejection_reason')" class="mb-0 mt-1">
                                <b-form-textarea size="sm" v-model="course.rejection_reason" rows="2"></b-form-textarea>
                                <b-button :variant="'primary'"
                                          v-if="!savedCourseIds.includes(course.id)"
                                          :disabled="checkApprover"
                                          class="font-weight-bold px-3 mt-2"
                                          @click="handleEvaluateCourse(course, 'rejected_and_reason', idx)">
                                    {{ $t('save') }}
                                </b-button>
                            </b-form-group>
                        </b-td>
                    </b-tr>
                </template>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import SpecialStudentApplicationService from "@/services/SpecialStudentApplicationService";
import { ValidationObserver } from 'vee-validate';
export default {
    name: "CourseReviewTab",
    components: {
        ValidationObserver
    },
    props: {
        localApp: {
            type: Object,
            required: true
        },
        isGraduate: {
            type: Boolean,
            required: true
        },
        checkApprover: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            evaluateCoursesLoading: false,
            savedCourseIds: []
        }
    },
    methods: {
        async handleEvaluateCourse(course, status, idx) {
            const observer = this.$refs['courseObserver' + idx][0];
            const isValid = await observer.validate();
            if (status === 'rejected') {
                this.$set(course, 'status', status);
                return;
            }
            if (!isValid) return;
            this.evaluateCoursesLoading = true;
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_approve'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const data = {
                                course_id: course.id,
                                status: status === 'rejected_and_reason' ? 'rejected' : status,
                                rejection_reason: course.rejection_reason ?? null
                            };

                            // Onay durumunda açıklama alanı gereksizdir.
                            if (course.status === 'approved') {
                                delete data.rejection_reason;
                            }

                            const res = await SpecialStudentApplicationService.evaluateCourse(this.localApp.id, data);
                            this.$emit('update-application', res.data.data);
                            this.savedCourseIds.push(course.id);
                            this.$toast.success(this.$t('proccess_success'));
                        } catch (error) {
                            this.showErrors(error, observer);
                        } finally {
                            this.evaluateCoursesLoading = false;
                        }
                    } else {
                        this.evaluateCoursesLoading = false;
                    }
                });
        }
    }
}
</script>

<style scoped>
.badge-success {
    background-color: #28a745;
    color: white;
}
</style>
